export const EVALUATION_PLAYBOOK_OVERRIDE_MAX_CATEGORIES = 10;
export const EVALUATION_PLAYBOOK_OVERRIDE_MAX_CHARS = 8_000;
export const EVALUATION_OVERLAY_MAX_BYTES = 96_000;

export function evaluationOverlayByteLength(overlay: unknown): number {
  const encoded = JSON.stringify(overlay);
  let bytes = 0;

  for (const character of encoded) {
    const codePoint = character.codePointAt(0) ?? 0;

    if (codePoint <= 0x7f) {
      bytes += 1;
    } else if (codePoint <= 0x7ff) {
      bytes += 2;
    } else if (codePoint <= 0xffff) {
      bytes += 3;
    } else {
      bytes += 4;
    }
  }

  return bytes;
}

export function evaluationOverlayExceedsMaxBytes(overlay: unknown): boolean {
  return evaluationOverlayByteLength(overlay) > EVALUATION_OVERLAY_MAX_BYTES;
}

export const EVALUATION_PLAYBOOK_PHASES = [
  'prompt-extension',
  'methodology',
  'planning',
  'payloads',
  'end-condition',
  'post-attack',
] as const;

export type EvaluationPlaybookPhase =
  (typeof EVALUATION_PLAYBOOK_PHASES)[number];

export type EvaluationPlaybookPhasesFilterShape = {
  readonly include?: readonly EvaluationPlaybookPhase[];
  readonly exclude?: readonly EvaluationPlaybookPhase[];
};

export function findContradictoryPlaybookPhases(
  filter: EvaluationPlaybookPhasesFilterShape,
): EvaluationPlaybookPhase[] {
  const { include, exclude } = filter;

  if (!include || !exclude) {
    return [];
  }

  const excluded = new Set(exclude);

  return include.filter((phase) => excluded.has(phase));
}

export function isEvaluationPlaybookPhaseEnabled({
  phase,
  filter,
}: {
  phase: EvaluationPlaybookPhase;
  filter?: EvaluationPlaybookPhasesFilterShape;
}): boolean {
  if (!filter) {
    return true;
  }

  const { include, exclude } = filter;

  if (include && !include.includes(phase)) {
    return false;
  }

  return !exclude?.includes(phase);
}
